<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">Locations List</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select class="select-default" v-model="pagination.per_page" placeholder="Per page" @change="changePerPage()">
            <el-option class="select-default" v-for="item in perPageOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input
              class="input-sm"
              placeholder="Search"
              v-model="searchQuery"
              addon-right-icon="nc-icon nc-zoom-split"
            ></fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped" :data="tableData" border style="width: 100%;" height="600">
            <el-table-column
              v-for="(column, index) in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              :sortable="column.sortable || false"
              :align="column.align"
              :header-align="column.align"
              v-if="!column.hidden"
              :fixed="column.fixed || false"
            ></el-table-column>

            <el-table-column :min-width="150" fixed="right" class-name="td-actions" label="Actions">
              <template slot-scope="props">
                <p-button type="info" size="sm" icon @click="handleLike(props.$index, props.row)">
                  <i class="fa fa-eye"></i>
                </p-button>
                <p-button
                  type="success"
                  size="sm"
                  icon
                  @click="handleEdit(props.$index, props.row)"
                >
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button
                  type="danger"
                  size="sm"
                  icon
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-trash"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries</p>
        </div>
        <div class="col-sm-6">
          <p-pagination
            class="pull-right"
            v-model="pagination.current_page"
            :per-page="Number.parseInt(pagination.per_page)"
            :total="pagination.total"
            @input="changePage()"
          ></p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
// import users from "../Tables/users.js";
import swal from 'sweetalert2'
import { mapGetters } from "vuex";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);

export default {
  components: {
    PPagination,
  },
  mounted() {
    this.$store.dispatch("fetchLocations", { per_page: 10, page: 1});
  },
  watch: {
      searchQuery: function (val) {
          this.$store.dispatch("fetchLocations", {
              searchQuery: this.searchQuery,
              per_page: this.pagination.per_page,
              page: this.pagination.current_page
          }); 
      }
  },
  computed: {
    ...mapGetters({
      tableData: "getLocations",
      pagination: "getPagination"
    }),
    // pagedData() {
    //   if(this.locations)
    //   return this.locations.slice(this.from, this.to);
    // },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      // if (!this.searchQuery) {
      //   if(this.locations)
      //   this.pagination.total = this.locations.length;
      //   else
      //   this.pagination.total = 0
      //   return this.pagedData;
      // }
      // let result = this.locations.filter(row => {
      //   let isIncluded = false;
      //   for (let key of this.propsToSearch) {
      //     let rowValue = row[key].toString();
      //     if (rowValue.includes && rowValue.includes(this.searchQuery)) {
      //       isIncluded = true;
      //     }
      //   }
      //   return isIncluded;
      // });
      // this.pagination.total = result.length;
      // return result.slice(this.from, this.to);
    },
  },
  data() {
    return {
      perPageOptions: ["10", "30", "50", "100", "250", "500"],
      searchQuery: "",
      propsToSearch: ["location_id", "name", "address_line", "city", "state", "country", "pincode", "email", "phone", "gstin"],
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
          hidden: true,
          align: 'center'
        },
        {
          prop: "location_id",
          label: "LOC ID",
          minWidth: 150,
          fixed: true,
          sortable: true,
          align: 'center'
        },
        {
          prop: "name",
          label: "Name",
          minWidth: 250,
          sortable: true,
          align: 'left'
        },
        {
          prop: "address_line",
          label: "Address",
          minWidth: 250,
          align: 'left'
        },
        {
          prop: "city",
          label: "City",
          minWidth: 150,
          sortable: true,
          align: 'left'
        },
        {
          prop: "state",
          label: "State",
          minWidth: 150,
          sortable: true,
          align: 'left'
        },
        {
          prop: "country",
          label: "Country",
          minWidth: 150,
          sortable: true,
          align: 'left'
        },
        {
          prop: "pincode",
          label: "Pincode",
          minWidth: 150,
          sortable: true,
          align: 'center'
        },
        {
          prop: "email",
          label: "Email",
          minWidth: 250,
          align: 'left'
        },
        {
          prop: "phone",
          label: "Phone",
          minWidth: 200,
          align: 'left'
        },
        {
          prop: "gstin",
          label: "GSTIN",
          minWidth: 200,
          align: 'left'
        }
      ],
      // tableData: this.locations
    };
  },
  methods: {
    changePerPage(){
      this.$store.dispatch("fetchLocations", { per_page : this.pagination.per_page, page : 1, searchQuery : this.searchQuery});
    },
    changePage(){
      this.$store.dispatch("fetchLocations", { per_page : this.pagination.per_page, page : this.pagination.current_page, searchQuery : this.searchQuery});
    },
    handleLike(index, row) {
      // alert(`Your want to like ${row.name}`);
      this.$router.push(`/locations/view/${row.id}`)
    },
    handleEdit(index, row) {
      this.$router.push(`/locations/edit/${row.id}`)
    },
    handleDelete(index, row) {
      // this.$store.dispatch('deleteLocation', row.id)
      swal({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-default btn-fill",
          confirmButtonText: "Delete it!",
          buttonsStyling: false
      })
      .then(result => { this.$store.dispatch("deleteLocation", row.id); })
      .catch(cancel => { console.log(cancel) });
    }
  }
};
</script>

<style lang="scss">
  .el-table .td-actions {
    button.btn {
      margin-right: 5px;
    }
  }


  .el-table, 
  .el-table tr, 
  .el-table thead th {
    background-color: white!important;
  }
</style>
